import React from "react";
import "./FounderSection.css";
import founderImg from "../images/ashishss.jpeg";

const FounderSection = () => {
  return (
    <section className="founder-section">
      <div className="founder-container">

        <div className="founder-image">
          <img src={founderImg} alt="Founder" />
        </div>

        <div className="founder-content">
          <p>
            Ashish Gupta is an alumnus of the prestigious Owner President
            Management program at the Harvard Business School, an ICWA topper,
            with an MBA from University of Wales, United Kingdom. He has an
            experience of running successful enterprises for over 25 years.
          </p>

          <p>
            Ashish took over the reins of Intrading in early 2012 with a view
            to build an integrated organization with world-class products in
            the Solid Wood Industry. Intrading is driven by his vision of
            redefining living spaces with high quality and durable solid wood
            furniture.
          </p>

          <p>
            With over two decades of experience in the Home Furnishing
            Industry, Ashish has successfully developed an essential supply
            base in India exporting to premium global customers across 84
            countries.
          </p>

          <h2>INTRADING</h2>
        </div>

      </div>
    </section>
  );
};

export default FounderSection;